import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'IconArrowLeft',
  props: {
    rotate: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["w-6 h-6", {'rotate-180': props.rotate && !props.vertical, '-rotate-90': props.rotate && props.vertical}]),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.8 3.5C16.4 3.1 15.8 3.1 15.4 3.5L6.9 12L15.4 20.5C15.8 20.9 16.4 20.9 16.8 20.5C17.2 20.1 17.2 19.5 16.8 19.1L9.7 12L16.8 4.9C17.2 4.5 17.2 3.9 16.8 3.5Z",
      fill: "currentColor"
    }, null, -1)
  ]), 2))
}
}

})